(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search-1"] && !Shopify.designMode) return;
  try {
    class DetailsDrawer extends HTMLElement {
    constructor() {
      super();
      this.detailsElement = this.querySelector('details');
      this.summaryElement = this.querySelector('summary');
      this.drawerElement = this.querySelector('.search-drawer');
      this.closeButton = this.querySelector('.drawer__close-button');
      this.closeMask = this.querySelector('.modal-overlay');
      this.searchInput = this.querySelector('.search__input');
      this.resetButton = this.querySelector('.reset__button');

      this.bindEvents();
    }

    bindEvents() {
      this.summaryElement.addEventListener('click', this.onSummaryClick.bind(this));
      this.closeButton.addEventListener('click', this.close.bind(this));
      this.closeMask.addEventListener('click', this.close.bind(this));
      this.addEventListener('keyup', this.onKeyUp.bind(this));

      if (this.searchInput && this.resetButton) {
        this.searchInput.addEventListener('input', () => {
          this.resetButton.classList.toggle('hidden', !this.searchInput.value.length);
        });
      }
    }

    onSummaryClick(event) {
      event.preventDefault();
      this.detailsElement.hasAttribute('open') ? this.close() : this.open();
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      if (!this.detailsElement.hasAttribute('open')) return;
      this.close();
    }

    open() {
      this.detailsElement.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');

      requestAnimationFrame(() => {
        this.searchInput.focus();
      });
    }

    close() {
      this.detailsElement.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    }
  }

  customElements.define('details-drawer', DetailsDrawer);
  } catch(e) { console.error(e); }
})();

})();
